import ct from 'crypto-js';

export function crypto() {

}

crypto.prototype.md5=function(u){
    return ct.MD5(u).toString()
}